// components/common/StepFormButtons.jsx
import { Button } from "@/components/ui/button";
import { ButtonType } from "../lib/Button";
import { Link } from "react-router-dom";

const StepFormButtons = ({
  type = "create",
  status,
  step = 0,
  totalSteps = 3,
  onNext,
  onBack,
  onSubmit,
  onDraftSave,
  cancelLink = "/",
  isLoading = false,
}) => {
  const showDraftButton = type !== "update" || status === "draft";

  return (
    <div className="flex justify-between items-center gap-5 max-w-screen-md mx-auto mt-5">
      {step === 0 ? (
        <Link className="w-full" to={cancelLink}>
          <Button type="button" className="w-full bg-cred text-cwhite">
            Cancel
          </Button>
        </Link>
      ) : (
        <Button
          type="button"
          onClick={onBack}
          className="w-full bg-cred text-cwhite"
        >
          Back
        </Button>
      )}

      {showDraftButton && (
        <Button
          type="button"
          className="w-full bg-cyellow text-black"
          onClick={onDraftSave}
          disabled={isLoading}
        >
          Save as Draft
        </Button>
      )}

      {step < totalSteps - 1 && (
        <Button
          type="button"
          disabled={isLoading}
          className="w-full bg-cgreen text-cwhite"
          onClick={onNext}
        >
          Next
        </Button>
      )}

      {step === totalSteps - 1 && (
        <Button
          isLoading={isLoading}
          type="submit"
          onClick={onSubmit}
          disabled={isLoading}
          className="w-full bg-cgreen text-cwhite"
        >
          {type === "update" ? "Publish" : "Publish"}
        </Button>
      )}
    </div>
  );
};

export default StepFormButtons;

// how to use
{
  /* <StepFormButtons
  step={step}
  totalSteps={stepLabels.length}
  cancelLink="/backoffice/menu/drinks"
  onBack={() => setStep((prev) => Math.min(prev - 1, stepLabels.length - 1))}
  onNext={() => setStep((prev) => Math.min(prev + 1, stepLabels.length - 1))}
  onSubmit={onSubmit}
  onDraftSave={() => {
    console.log("Save as Draft clicked");
  }}
/> */
}
